import { searchBlogsRequest, searchSingleBlogsSuccess, searchBlogsError } from '../../ducks/strapi.duck';

const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL;

export const loadData = (params, search, config) => {
  const slug = params?.title;

  return async (dispatch) => {
    dispatch(searchBlogsRequest());
    try {
      const url = `${STRAPI_BASE_URL}/api/blogs?filters[slug][$eq]=${encodeURIComponent(slug)}&populate=*`;

      const response = await fetch(url);
      const json = await response.json();

      const blogData = json?.data;
      if (blogData && blogData.length > 0) {
        dispatch(searchSingleBlogsSuccess(blogData[0]));
      }
    } catch (error) {
      dispatch(searchBlogsError());
    }
  };
};
